import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-pagenotfound',
    templateUrl: './pagenotfound.component.html',
    styleUrls: ['./pagenotfound.component.scss'],
    standalone: false
})
export class PagenotfoundComponent {

  currentUser:any;
  mainMessage :string = '';

  modalMessage :string = '';
  errorDetails:any;
  constructor(private router: Router) {
    this.currentUser = localStorage.getItem("currentUser") ? JSON.parse(localStorage.getItem("currentUser")) : null;
    const navigation = this.router.getCurrentNavigation();
    
    if (navigation?.extras.state && navigation.extras.state['errorData']) {
      this.errorDetails = navigation.extras.state['errorData'];
      
      // Use the error description for the main message if available
      if (this.errorDetails.errorDescription && this.errorDetails.errorDescription.length > 0) {
       this.mainMessage ="Invalid Document"
        // this.modalMessage = this.errorDetails.errorDescription[0];
      }
    } else {
      // Handle direct access to the error page or missing data
     this.mainMessage ="Invalid Resource!"
        this.modalMessage = ''
    }
  }

    // }else{
    //   this.router.navigate(['login']);
    
  
 // errorCode: string =  history.state.data? history.state.data :'404';
 // errorMap = {'400': 'Bad Request', '401': 'Access To This Resource Is Forbidden', '403': 'Authorization Required', '404': 'Something Gone Wrong', '500': 'Internal Server Error' };
}
